/*
 * @Author: edvardchen
 * @Date:   2016-08-21 17:08:06
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:57:30
 */
import querystring from 'query-string';
import React from 'react';
import PropTypes from 'prop-types';
import isFeedsFast from '../../utility/isFeedsFast';
import { isLoadKuaiBao } from '../../utility/PageConfigDataForShare';

if (__CLIENT__) {
  require('./ReadAllMask.scss');
}

export default class ReadAllMask extends React.PureComponent {
  static propTypes = {
    onReadAll: PropTypes.func.isRequired,
    onExposure: PropTypes.func,
    share: PropTypes.bool,
    onClickReadAll: PropTypes.func,
    isChangeButtonStyle: PropTypes.bool, // 是否改变阅读全文按钮样式
  };

  constructor(props) {
    super(props);
    this.onExposure = this.props.onExposure;
    this.state = {
      lang: 'ch',
    };
  }
  /* eslint-disable react/no-did-mount-set-state */
  componentDidMount() {
    const query = window && window.location.search;
    const { lang } = querystring.parse(query) || {};
    this.setState({
      lang: lang || 'ch',
    });
  }

  render() {
    const txt = this.state.lang === 'ch' ? '查看全文' : 'See All';
    let btnText = '打开QQ浏览器，阅读体验更佳';
    let kbClass = '';
    if (isFeedsFast()) {
      btnText = '打开天天快报极速版，阅读体验更佳';
      kbClass = 'is-kb__mask_btn';
    }

    // 拉新拉活看点快报
    if (isLoadKuaiBao()) {
      btnText = '打开看点快报，阅读体验更佳';
      kbClass = 'is-kb__mask_btn';
    }

    return (
      <div
        className={`article-mask ${this.props.share ? 'is-share' : ''}`}
        ref={(node) => {
          this.el = node;
        }}
      >
        {!this.props.share ? (
          <a href="javascript:" className="read-all" onClick={this.props.onReadAll}>
            {txt}
            <i className="G-ico G-ico-arr-down" style={{ background: 'transparent!important' }}></i>
          </a>
        ) : (
          <div className="article-mask-area">
            <div className="article-mask--more" onClick={this.props.onReadAll}>
              <i className={`G-icon--more ${kbClass}`} />
            </div>
            <div
              className={`article-mask--openqb-new ${
                this.props.isChangeButtonStyle ? 'article-mask--openqb-new-active' : ''
              } ${kbClass}`}
              onClick={() => {
                this.props.onReadAll();
                this.props.onClickReadAll();
              }}
            >
              {btnText}
            </div>
          </div>
        )}
      </div>
    );
  }
}
